import { render, staticRenderFns } from "./provlente.vue?vue&type=template&id=314645d7&"
import script from "./provlente.vue?vue&type=script&lang=js&"
export * from "./provlente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports